import React from "react";
import { dialog, Button, Progress, InfiniteScroll } from "nq-component";
import Table from "../../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import BaseListPage from "../../../../../base/BaseListPage";

import Deduction from "./DisbursementAction/DisbursementDeductions/Deduction";
import DeductionEdit from "./DisbursementAction/DisbursementDeductions/DeductionEdit";
import { v4 as uuidv4 } from "uuid";
import DisbursementsPresenter from "../../DisbursementsPresenter";

export default class DisbursementDeductionTable extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new DisbursementsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      object: [],
      objectID: "",
      objects: [],
      limit: 10,
      current: 1,
      count: 0,
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.objectID !== this.props.objectID) {
      this.setState({
        objectID: this.props.objectID,
      });
    }
    if (prevProps.childData !== this.props.childData) {
      this.setState({
        object: this.props.childData,
      });
    }
    if (prevState.object !== this.state.object) {
      // }
      if (this.state.object.length > 0) {
        this.props.earningData(this.state.object);
      }
    }
  }

  getCollectionName() {
    return "deduction";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleAction(action, data) {
    this.setState({ [action]: true, [action + "Data"]: data });
  }

  async handleEditData(id) {
    this.setState({ objectID: id });
  }

  Deduction(deduction, isUpdate = false) {
    this.setState((prevState) => {
      let objects;
      if (isUpdate) {
        objects = prevState.object.map((obj) =>
          obj.description === deduction.description
            ? { ...obj, ...deduction }
            : obj
        );
      } else {
        if (this.state.objectID === "") {
          const objectID = uuidv4();
          this.setState({ objectID });
          const newErning = { ...deduction, disbursementNum: objectID };
          this.props.getObjectId(newErning.disbursementNum);
          objects = [...prevState.object, newErning];
        } else {
          const newErning = {
            ...deduction,
            disbursementNum: this.state.objectID,
          };
          objects = [...prevState.object, newErning];
        }
      }
      return { object: objects };
    });
  }

  handleObjectData(data) {
    dialog.fire({
      html: (
        <DeductionEdit Deduction={this.Deduction.bind(this)} object={data} />
      ),
      footer: false,
    });
  }

  educationalBackground() {
    dialog.fire({
      html: <Deduction Deduction={this.Deduction.bind(this)} />,
      footer: false,
    });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { object, count, limit, current } = this.state;
    if (!schema) return <Progress />;
    return (
      <div className="overflow-auto">
        <InfiniteScroll className="h-100">
          <div className="p-3 p-lg-4">
            <div style={{ marginTop: "20px", width: "100%" }}>
              <div className="d-flex align-items-center justify-content-center">
                <div style={{ marginLeft: "auto" }}>
                  <Button
                    type="button"
                    onClick={this.educationalBackground.bind(this)}
                  >
                    <i className="bi bi-plus-lg" /> Add
                  </Button>
                </div>
              </div>
              <label>
                <b>Deductions</b>
              </label>
            </div>
            <Table
              objectData={this.handleObjectData.bind(this)}
              editId={this.handleEditData.bind(this)}
              fields={schema.fields}
              objects={object}
              collection={schema}
              count={count}
              limit={limit}
              current={current}
              loadPagination={this.onClickPagination.bind(this)}
              actionsList={[
                {
                  label: "Edit",
                  actionType: "object",
                },
              ]}
              excludeFields={Object.keys(schema.fields).reduce(
                (acc, key) => {
                  const options = schema.fields[key];
                  if (options.read === false) {
                    acc.push(key);
                  }
                  switch (options._type || options.type) {
                    case "Relation":
                    case "Array":
                    case "Object":
                    case "File":
                      acc.push(key);
                      break;
                    default:
                  }
                  return acc;
                },
                ["Id", "Created At", "Updated At"]
              )}
              onClickItem={this.onClickItem.bind(this)}
            />
          </div>
        </InfiniteScroll>
      </div>
    );
  }
}
